import {
  AbstractSectionName,
  AspectRatio,
  DefaultSectionName,
  FIELD_ROLES,
  ImageResolution,
  SectionName,
} from './types';

export const AI_IMAGE_GENERATION_SERVERLESS_BASE_URL =
  'https://editor.wix.com/_serverless/ai-image-generation/';

export const ScenePromptIds: Record<SectionName, string> = {
  [DefaultSectionName.WELCOME]: '18746c5f-c5da-4b51-a79e-f8fe96745261',
  [DefaultSectionName.ABOUT]: '38bcf7b9-e274-4e8b-a4e1-f46faafbad93',
  [DefaultSectionName.GALLERY]: '08359693-0219-4161-bdf9-00316386c68c',
  [DefaultSectionName.INSTAGRAM]: '08359693-0219-4161-bdf9-00316386c68c',
  [DefaultSectionName.GENERAL]: '08359693-0219-4161-bdf9-00316386c68c',
  [AbstractSectionName.ABSTRACT]: '08359693-0219-4161-bdf9-00316386c68c',
};

export const STRUCTURE_ID = 'a1ccf441-4e3b-4d9c-90bb-dd4143a5cd3d';

export const SD_CORE_IMAGE_GENERATION_PROMPT_ID =
  '52994cc0-0d0d-405c-bf62-64f521d48c95';

export const FLUX_PRO_ULTRA_IMAGE_GENERATION_PROMPT_ID =
  '27a0da46-c70d-4e4f-8f21-a2f4403a664e';

export const BusinessTermsBlacklist = [
  '6048aa84be2ee2001584d159',
  '55d4e81833bc9eada9dffd0c',
  '5e8c1d214b7a4200177fd447',
  '6107f122eec48300158889ec',
  '5cf045c939e68000158a4464',
  '5fb61ada96417edd325f09eb',
  '714a7d52812e0df69b1634a3',
  'a4a33900f45ca67110f2dfc4',
  '5eb932ca20ff2b0017946414',
  '2e0d3d3432112b324361895a',
  'a4def3d162781f1e96ee1956',
  '8ad09c40cd032d6f157c3061',
  'c9eddd377e1a194896c3637c',
  '604f0ed3630fc000153966b2',
  '16f33903e614854d62828658',
  '1265240190ad56db08acdf09',
];

export const IMAGE_ASPECT_RATIO_BY_FIELD_ROLE: Record<
  FIELD_ROLES,
  AspectRatio
> = {
  [FIELD_ROLES.CROPTYPE_PORTRAIT]: '4:5',
  [FIELD_ROLES.CROPTYPE_LANDSCAPE]: '16:9',
  [FIELD_ROLES.CROPTYPE_ABSTRACT]: '16:9',
  [FIELD_ROLES.ABSTRACT]: '16:9',
};

export const WIDE_LANDSCAPE_IMAGE_ASPECT_RATIO = '21:9';
export const DEFAULT_IMAGE_ASPECT_RATIO: AspectRatio = '1:1';

export const IMAGE_RESOLUTION_BY_FIELD_ROLE: Record<
  FIELD_ROLES,
  ImageResolution
> = {
  [FIELD_ROLES.CROPTYPE_PORTRAIT]: { height: 1712, width: 1368 },
  [FIELD_ROLES.CROPTYPE_LANDSCAPE]: { height: 1152, width: 2040 },
  [FIELD_ROLES.CROPTYPE_ABSTRACT]: { height: 1152, width: 2040 },
  [FIELD_ROLES.ABSTRACT]: { height: 1152, width: 2040 },
};

export const WIDE_LANDSCAPE_IMAGE_RESOLUTION = {};

export const DEFAULT_IMAGE_RESOLUTION = { height: 1024, width: 1024 };

export const AiImageInjectionSectionsBlacklist = ['TeamMember', 'Footer'];
